import { useFormik } from "formik";
import { FrequencyFields } from "./frequency-fields";
import {
  CreateFrequencyRequestDTO,
  useCreateFrequencyMutation,
  useToast,
} from "@/hooks";
import { useTranslation } from "react-i18next";
import { frequencyValidationSchema } from "./frequency-validation";
import { Button } from "@/components/ui/button";
import { DisplayError } from "@/utils";

type FormFrequencyProps = {
  handleClose: () => void;
};

export function FormCreateFrequency({ handleClose }: FormFrequencyProps) {
  const { t } = useTranslation();
  const { toast } = useToast();

  const initialValues = {
    name: "LABEL.daily",
    days: "",
  };

  const { mutateAsync, isLoading } = useCreateFrequencyMutation();
  const { handleSubmit, getFieldProps, errors, touched, resetForm, setFieldValue, setFieldTouched } =
    useFormik({
      initialValues,
      validationSchema: frequencyValidationSchema,
      onSubmit: async (values) => {
        await handleCreateFrequencySubmit({ ...values, days: Number(values.days) });
      },
    });

  async function handleCreateFrequencySubmit(
    request: CreateFrequencyRequestDTO
  ) {
    try {
      await mutateAsync(request, {
        onSuccess: () => {
          toast({
            title: t("LABEL.success"),
            description: t("MESSAGE.created successfully"),
          });
          resetForm();
          handleClose();
        },
        onError: (error) => {
          toast({
            title: t("LABEL.error"),
            description: DisplayError(error, t("MESSAGE.error_message")),
            variant: "destructive",
          });
        },
      });
    } catch (error) {
      toast({
        title: t("LABEL.error"),
        description: DisplayError(error, t("MESSAGE.error_message")),
        variant: "destructive",
      });
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-10 px-4 pb-8">
      <FrequencyFields
        name={getFieldProps("name").value}
        daysProps={getFieldProps("days")}
        onNameChange={(value) => {
          void setFieldTouched("name", true);
          void setFieldValue("name", value);
        }}
        nameError={touched.name ? errors.name : undefined}
        daysError={touched.days ? errors.days : undefined}
      />
      <Button isLoading={isLoading} className="w-full">
        {t("LABEL.save")}
      </Button>
    </form>
  );
}
